import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../components/ui/button';
import { Dialog, DialogContent } from '../../../../components/ui/dialog';
import useLimits from '../../../plan/hooks/limits';
import { initMicrosoftTeamsCalendar } from '../../../../services/integrationService';
import MicrosoftIcon from '../../../../assets/icons/microsoftlogo.svg';

interface ConnectMicrosoftTeamsCalendarModalProps {
  onClose: () => void;
}

const ConnectMicrosoftTeamsCalendarModal = ({
  onClose,
}: ConnectMicrosoftTeamsCalendarModalProps) => {
  const guardLimits = useLimits();
  const { t } = useTranslation();

  const handleConnectMicrosoftTeamsCalendar = async () => {
    guardLimits('meetingBot', async () => {
      const response = await initMicrosoftTeamsCalendar();
      window.location.href = response.oauthUrl;
    });
  };

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md p-4 sm:p-6">
        <div className="flex flex-col items-center space-y-3 sm:space-y-4 py-4 sm:py-6">
          <img
            src={MicrosoftIcon}
            alt="Microsoft"
            className="w-10 h-10 sm:w-12 sm:h-12"
          />
          <h3 className="text-base sm:text-lg font-semibold text-center">
            {t(
              'settings.meetingBot.microsoftTeams.connectCalendar',
              'Connect Your Calendar',
            )}
          </h3>
          <p className="text-xs sm:text-sm text-muted-foreground text-center px-2">
            {t(
              'settings.meetingBot.microsoftTeams.allowAccess',
              'Automatically record and transcribe your meetings',
            )}
          </p>
          <Button
            onClick={handleConnectMicrosoftTeamsCalendar}
            data-testid="connect-microsoft-teams-calendar-button"
            className="w-full sm:w-auto"
          >
            <img src={MicrosoftIcon} alt="" className="w-4 h-4 mr-2" />
            {t('settings.meetingBot.microsoftTeams.connectButton', 'Connect')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConnectMicrosoftTeamsCalendarModal;
